<template>
  <div class="headBox">
      <!-- 标题文字 -->
      <div class="headInfo courseTitleTxt" :title="courseTitleTxt">
        <span>{{ courseTitleTxt }}</span>
      </div>

      <!--用户姓名-->
      <div v-if="(competeType == '0'||competeType == '1'||competeType == '3'||competeType == '4')" class="headInfo"  v-show="uiWidth > 800">
        <span>{{fullName}}</span>
      </div>

      <!--显示倒计时-->
      <div v-if="[1, 2, 4, 5].indexOf(competeType) >= 0" class="headInfo time_remain">
        {{$t('time_remain')}}
        <span 
          v-loading="loadingTimeShow" 
          element-loading-spinner="el-icon-loading" 
          element-loading-background="rgba(33,86,131, 1)">
          {{timeText}}
        </span> 
      </div>

      <!--显示课程进度-->
      <div
        class = "headInfo currentLevel"
        @click = "clickChangeLanMenu"
      >
        <div>
        <p class="levelInfo">{{ curLevelText }}</p>
        <p>
          <span class="stageInfo">♘ {{ minStep }}</span>
          <span class="stageInfo">☰ {{ minLine }}</span> 
        </p>
        </div>

      </div>

      <!-- 菜单 -->
      <div
        class="headBtn" 
        v-show="uiWidth > 900"
        @click="clickChangeLanMenu" >
        <span>☰ {{$t('menu')}}</span>
      </div>

      <!-- 切换语言 -->
      <div class="headBtn headLanguage" v-show="uiWidth > 1000" @click="clickChangeLanMenu1">
        <span>𑁍 {{ langText }}</span>

        <!-- 切换语言 下拉菜单 -->
        <ul v-show="langMenu">
          <li v-for="(name, lang) in lanMap" 
            :key="lang" 
            @click="changeLang(lang)" 
            v-show="$i18n.locale != lang">
            {{ name }}
          </li>
        </ul>
      </div>

    <!-- 返回主页按钮 -->
    <div class="headBtn" @click="goHomePage" v-show="uiWidth > 400">
      <span>☓ {{ $t('quit') }}</span>
    </div>
  






      

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "../../store";
import AdventureManager from "../../manager/AdventureManager";
import OperateDom from "../../manager/OperateDom";
import Const from "../../const/Const";
export default {
  data() {
    return {
      IMG_BASE_URL: process.env.IMG_BASE_URL,
      langMenu: false,
      langText: "",
      lanMap: {
        zh: "中文",
        en: "English",
        he: "עברית",
        // sp: "Español",
        // es: "Español",
        // fr: "Français",
        ar:'العربية',
        vi: 'Tiếng Việt',
        he:'עברית',
      },
      num: 0,
      txt: "",
      msg: "",
      timer: null,

      uiWidth: 0,
    };
  },
  mounted() {
    let lang = AdventureManager.getLanguage();
    this.$i18n.locale = lang;

    store.state.checkLangs = lang;
    
    this.langText = this.lanMap[lang];
    // 监听事件
    this.$nextTick(() => {
      window.addEventListener("click", () => {
        this._wantCloseLanMenu = true;
      });

      window.addEventListener("resize", this.headResize);
      this.headResize();
    });
    setTimeout(() => {
      store.state.loadingTimeShow = false;
      this.$i18n.locale = lang;
      store.state.checkLangs = lang;
    }, 2000);
  },
  components: {},
  methods: {
    headResize() {
      this.uiWidth = window.innerWidth || document.body.clientWidth;
    },

    update(dt) {
      if (this._wantCloseLanMenu && !this._wantHandleLanMenu) {
        this.langMenu = false;
      } else if (this._wantHandleLanMenu) {
        this.langMenu = !this.langMenu;
      }
      this._wantCloseLanMenu = false;
      this._wantHandleLanMenu = false;
    },
    // 显示代码索引弹窗
    showCodeIndexDialog() {
      AdventureManager.toFront_showCodeIndexDialog();
    },
    // 回到主页
    goHomePage() {
      if(store.state.competeType==Const.COMPETE_TYPE_TOUR){
        store.state.tourNotCompelete = true;
        store.state.customeType = 'TourNotComplete';
        return;
      }
      store.state.skipStyleShow = false;
      store.state.skipShow = false;
      store.state.toBack = true;

      AdventureManager.sendToGame("exitGame");
    },
    clickChangeLanMenu1() {
      this._wantHandleLanMenu = true;
    },
    // 点击切换语言菜单按钮
    clickChangeLanMenu() {
      if (store.state.menuFlag) return;
      store.state.menuFlag = true;
      store.state.knowledgeArr = window.bridge.getCourseList(0);
      store.state.CommandList = window.bridge.getCommandList(0);
      store.state.StoryIntroList = window.bridge.getStoryIntroList(0);
      store.state.highCheckShow = false;
      // 获取用户信息
      AdventureManager.getMenuInfo();
    },
    // 切换语言
    changeLang(lang) {
      store.state.checkLangs = lang;
      store.state.checkLangDialogShow = true;

      AdventureManager.setLanguage(lang)
      this.$i18n.locale = lang;
    },
    courseFilter(status) {
      return this.$t("course_"+status);
    },
    
  },
  computed: {
    ...mapGetters([
      "minLine",
      "minStep",
      "curLevelText",
      "allImageMap",
      "checkpointShow",
      "toBack",
      "dirLang",
      "level",
      "fullName",
      "userLastName",
      "userFirstName",
      "skipStyleShow",
      "Workspace",
      "chooseMode",
      "lang",
      "checkLangDialogShow",
      "checkLangs",
      "gameId",
      "times",
      "competeType",
      'edition',
      "timeText",
      "timeoverShow",
      "loadingTimeShow",
      "checkLangShow",
      "courseTitleTxt",
    ]),
    fullName() {
      if (this.$i18n.locale == "zh") {
        return (store.state.userLastName == undefined ? '' : store.state.userLastName) + store.state.userFirstName;
      } else {
        return store.state.userFirstName + " " + (store.state.userLastName == undefined ? '' : store.state.userLastName);
      }
    },
  },
};
</script>

<style scoped>
.headBox {
  height: 66px;
  z-index: 2;
  background-image:
    url("../../../static/images/headLeft.png"),
    url("../../../static/images/gameMain01.png"),
    url("../../../static/images/gameMain03.png"); 
  background-repeat: no-repeat, no-repeat, repeat-x;
  background-position:
    left,
    right,
    center;
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px;
}

.headBox .headInfo {
  background-image:
    url("../../../static/images/headItemLeft.png"),
    url("../../../static/images/gameMain04.png"),
    url("../../../static/images/gameMain_03_04.png"); 
  background-repeat: no-repeat, no-repeat, repeat-x;
  background-position:
    left,
    right,
    center;
  position: relative;
  height: 100%;
  padding: 0 24px;
  margin: 0 6px;

  font-size: 18px;
  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;
}

.headBox .headBtn {
  background: #0e81b6;
  border-radius: 5px;
  height: 45px;
  padding: 0 24px;
  margin: 0px 1px 6px 6px;
  font-size: 18px;
  color: #fff;

  display: flex;
  align-items: center;
  align-content: center;

  box-shadow: 2px 1px gray;
  transition: background-color 0.5s;
}

.headBox .headBtn:hover {
  height: 52px;
  background: #e9ae2c;
}

.headLeft {
  position: absolute;
  left: 0;
  top: 0;
  height: 66px;
  width: 81px;
}
.headRight {
  position: absolute;
  right: 0;
  height: 66px;
  min-width: 444px;
  background-repeat: repeat-x;
}
.lastBg {
  width: 26px;
  height: 66px;
  float: right;
}
.firstBg {
  width: 37px;
  height: 66px;
  float: left;
}

.headRight-btnr {
  width: 65px;
  height: 56px;
  float: right;
  cursor: pointer;
  margin-left: 40px;
}
.time_remain {
  width: 149px;
  height: 49px;
  float: right;
  text-align: center;
  line-height: 49px;
  color: #fff;
  font-size: 18px;
  margin-top: 7px;
  margin-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.currentLevel {
  cursor: pointer;
}

p.levelInfo {
  font-size: 20px;
  margin-top: 4px;
  text-align: center;
}

span.stageInfo {
  font-size: 10px;
  margin-left: 5px;
  margin-right: 5px;
}

.courseTitleTxt {
  overflow: clip;
  flex: 1;
}

.headLanguage > ul {
  position: absolute;
  top: 60px;
  z-index: 11;
  margin-left: -24px;
}
.headLanguage > ul > li {
  /* 选择语言菜单 下拉按钮 */
  box-sizing: border-box;
  height: 52px;
  color: #ffffff;
  position: relative;
  cursor: pointer;
  background-color: #0e81b6;
  text-align: center;
  font-size: 20px;
  line-height: 52px;
  margin: 1px;
  padding: 0 10px;
}

.headLanguage > ul > li:last-child {
  border-radius: 0 0 6px 6px;
}

.headLanguage > ul > li:hover {
  /* 选择语言菜单 下拉按钮 鼠标放上面时*/
  background-color: #e9ae2c;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineClass/head.vue